// extracted by mini-css-extract-plugin
export default {"wrapper":"TopHeader_wrapper__9gVa3","img":"TopHeader_img__tiju3"};